import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { ProblemSection } from './components/sections/ProblemSection';
import { SolutionSection } from './components/sections/SolutionSection';
import { TransformationSection } from './components/sections/TransformationSection';
import { ForYouSection } from './components/sections/ForYouSection';
import { VolumesSection } from './components/sections/VolumesSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { OfferSection } from './components/sections/OfferSection';
import { GuaranteeSection } from './components/sections/GuaranteeSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { AboutSection } from './components/sections/AboutSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { Footer } from './components/sections/Footer';
export function App({
  showSocialProofPopup = true
}: {
  showSocialProofPopup?: boolean;
}) {
  return <div className="w-full overflow-x-hidden bg-white" data-id="element-0" data-mp="3rdkh85pvcjnt">
      <MetaPixel data-id="element-1" data-mp="5or2zhbcs60" />
      <main data-id="element-2" data-mp="680tswt8a8y">
        <Hero data-id="element-3" data-mp="4wylxj0jajy" />
        <ProblemSection data-id="element-4" data-mp="5ghbgghm2z1" />
        <SolutionSection data-id="element-5" data-mp="7svdij4jt6t" />
        <TransformationSection data-id="element-6" data-mp="2zllff2q1qmn9" />
        <ForYouSection data-id="element-7" data-mp="2zmenq84nlk7i" />
        <VolumesSection data-id="element-8" data-mp="2zn6actg9w7ln" />
        <BonusesSection data-id="element-9" data-mp="33morde4z3yj7" />
        <OfferSection data-id="element-10" data-mp="33lwzoeehyky7" />
        <GuaranteeSection data-id="element-11" data-mp="33n6zp94wu37h" />
        <TestimonialsSection data-id="element-12" data-mp="33orkw85c49so" />
        <AboutSection data-id="element-13" data-mp="38l8idsyfc0if" />
        <FaqSection data-id="element-14" data-mp="38kqafz2efxuo" />
        <FinalCtaSection data-id="element-15" data-mp="38k6x6vnp1xmz" />
      </main>
      <Footer data-id="element-16" data-mp="3dkurprb4swly" />
      <FloatingCTA data-id="element-17" data-mp="3dle46si0issl" />
      {showSocialProofPopup && <PurchasePopup data-id="element-18" data-mp="3dm5y7yvyoigr" />}
    </div>;
}